export default __webpack_public_path__ + "static/Nunito-Regular-a427ddbe4dc20889d6e0ac752dce4bea.ttf";